import { Pipe, PipeTransform } from '@angular/core';
import { Helper } from '../../classes/helper';
import { Listing } from '../../classes/listing';

/*
 * returns a courtesy of... message based on listing agent info
*/
@Pipe({ name: 'courtesyMessage' })
export class CourtesyMessagePipe implements PipeTransform {
  transform(listing: Listing): string {
    const agentIncorporation = listing.agentIncorporation || (listing.agent ? listing.agent.agentIncorporation : '');
    const agentName = listing.remaxAgentName || (listing.agent ? listing.agent.fullName : '');
    const officeName = listing.remaxOfficeName || (listing.agent ? listing.agent.officeName : '');
    // Scenario 3: Listing with incorporated agent
    if (agentIncorporation) {
      if (agentName && agentIncorporation === 'Personal Real Estate Corporation') {
        return `${agentName}, ${officeName}`;
      }
      return agentIncorporation;
    }
    // Scenario 2: Listing with associated agent
    else if (agentName) {
      return `${agentName}, ${officeName}`;
    }
    else {
      // Scenario 1 / catchall
      return officeName;
    }
  }
}
